/*
 * @Author: Phoenix
 * @Date: 2020-03-26 16:00:46
 * @LastEditTime: 2021-01-18 17:33:17
 * @Description: routes of admin user
 * @FilePath: /ups-single-window-web/src/router/modules/admin.js
 * @未经本人许可，任何单位及个人不得以任何方式对本产品进行使用、复制、修改、抄录、传播或与其它产品捆绑使用、销售。
 */
import roles from '../roles'

import Layout from '@/layout/index.vue'

export default [
  {
    path: '/admin-welcome',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        hidden: true,
        component: () => import('@/views/welcome/index.vue')
      }
    ]
  },
  {
    path: '/customs-clearance',
    component: Layout,
    name: 'admin-customs-clearance',
    meta: { title: '报关单证', icon: 'clearance-choose-dark', roles: [roles.roleAdmin, roles.roleOperator], permissionTag: 'declarations:management', level: 1 },
    children: [
      {
        path: 'export',
        component: () => import('@/views/admin/admin-clearance/index.vue'),
        name: 'admin-clearance-export',
        meta: { title: '出口报关', permissionTag: 'declarations:management', level: 2 },
        children: [
          {
            path: 'export-b',
            component: () => import('@/views/admin/admin-clearance-b/export/index.vue'),
            name: 'admin-clearance-export-b',
            meta: { title: '个人物品申报(B类)', permissionTag: 'declarations:management', level: 3 }
          },
          {
            path: 'export-c',
            component: () => import('@/views/admin/admin-clearance-c/export/index.vue'),
            name: 'admin-clearance-export-c',
            meta: { title: '低值货物快件(C类)', permissionTag: 'declarations:management', level: 3 }
          },
          {
            path: 'export-d',
            component: () => import('@/views/admin/admin-clearance/export/index.vue'),
            name: 'admin-clearance-export-d',
            meta: { title: '正式申报类货物(D类)', permissionTag: 'declarations:management', level: 3 }
          }
        ]
      },
      {
        path: 'import',
        component: () => import('@/views/admin/admin-clearance/index.vue'),
        name: 'admin-clearance-import',
        // hidden: process.env.VUE_APP_ENV === 'production',
        meta: { title: '进口报关', permissionTag: 'declarations:management', level: 2 },
        children: [
          {
            path: 'import-b',
            component: () => import('@/views/admin/admin-clearance-b/import/index.vue'),
            name: 'admin-clearance-import-b',
            // hidden: process.env.VUE_APP_ENV === 'production',
            meta: { title: '个人物品申报(B类)', permissionTag: 'declarations:management', level: 3 }
          },
          {
            path: 'import-c',
            component: () => import('@/views/admin/admin-clearance-c/import/index.vue'),
            name: 'admin-clearance-import-c',
            // hidden: process.env.VUE_APP_ENV === 'production',
            meta: { title: '低值货物快件(C类)', permissionTag: 'declarations:management', level: 3 }
          },
          {
            path: 'import-d',
            component: () => import('@/views/admin/admin-clearance/import/index.vue'),
            name: 'admin-clearance-import-d',
            // hidden: process.env.VUE_APP_ENV === 'production',
            meta: { title: '正式申报类货物(D类)', permissionTag: 'declarations:management', level: 3 }
          }
        ]
      },
      {
        path: '/detail',
        component: () => import('@/views/admin/admin-clearance/detail/index.vue'),
        name: 'admin-clearance-detail',
        meta: { title: '报关详情', activeMenu: '' },
        hidden: true
      },
      {
        path: '/detail-c',
        component: () => import('@/views/admin/admin-clearance-c/detail/index.vue'),
        name: 'admin-clearance-detail-c',
        meta: { title: '报关详情', activeMenu: '' },
        hidden: true
      },
      {
        path: '/detail-b',
        component: () => import('@/views/admin/admin-clearance-b/detail/index.vue'),
        name: 'admin-clearance-detail-b',
        meta: { title: '报关详情', activeMenu: '' },
        hidden: true
      }
    ]
  },
  {
    path: '/clearance-exception',
    component: Layout,
    meta: { title: '清关异常', icon: 'clearancefalse-dark', roles: [roles.roleAdmin, roles.roleOperator], permissionTag: 'clearance:management', level: 1 },
    children: [
      {
        path: '',
        redirect: 'export',
        hidden: true
      },
      {
        path: '/clearance-exception/export',
        component: () => import('@/views/admin/clearance-exception/export/index.vue'),
        name: 'clearance-exception-export',
        meta: { title: '出口异常', permissionTag: 'clearance:management', level: 2 }
      },
      {
        path: '/clearance-exception/import',
        component: () => import('@/views/admin/clearance-exception/import/index.vue'),
        name: 'clearance-exception-import',
        meta: { title: '进口异常', permissionTag: 'clearance:management', level: 2 }
      },
      {
        path: '/clearance-exception/createException',
        component: () => import('@/views/admin/clearance-exception/createException/index.vue'),
        name: 'create-exception-import',
        hidden: true,
        meta: { title: '创建异常', activeMenu: '', level: 2 }
      }
    ]
  },
  {
    path: '/customers-profile',
    component: Layout,
    meta: { title: '客户管理', icon: 'profilefalse-dark', roles: [roles.roleAdmin, roles.roleOperator], permissionTag: 'customers:management', level: 1 },
    children: [
      {
        path: '/customers-profile',
        component: () => import('@/views/admin/customers-profile/index.vue'),
        name: 'customers-profile-list',
        meta: { title: '客户档案', permissionTag: 'customers:management', level: 2 }
      },
      {
        path: '/ai-create',
        component: () => import('@/views/admin/customers-profile/ai-create/index.vue'),
        name: 'ai-create',
        meta: { title: 'AI创建报关单', permissionTag: 'customers:management', level: 2, subIcon: 'ai_menu_icon' }
      },
      {
        path: '/assist-to-create',
        component: () => import('@/views/admin/assist-to-create/index.vue'),
        name: 'assist-to-create',
        meta: { title: '协助创建报关单', permissionTag: 'customers:management', level: 2 }
      },
      {
        path: '/mapping-list',
        component: () => import('@/views/admin/mapping-management/index.vue'),
        name: 'mapping-management-list',
        meta: { title: '映射方案管理', permissionTag: 'customers:management', level: 2 }
      },
      {
        path: '/mapping-detail',
        component: () => import('@/views/admin/mapping-management/mapping-detail/index.vue'),
        name: 'mapping-management-detail',
        hidden: true,
        meta: { title: '映射方案详情', activeMenu: '/mapping-management/' }
      },
      {
        path: '/mapping-create',
        component: () => import('@/views/admin/mapping-management/mapping-create/index.vue'),
        name: 'mapping-management-create',
        hidden: true,
        meta: { title: '映射方案详情', activeMenu: '/mapping-management/' }
      },
      {
        path: '/customers-detail',
        component: () => import('@/views/admin/customers-profile/customers-detail/index.vue'),
        name: 'customers-profile-detail',
        hidden: true,
        meta: { title: '客户详情', activeMenu: '/customers-profile/' }
      }, {
        path: '/opera-record',
        component: () => import('@/views/admin/customers-profile/opera-record/index.vue'),
        name: 'customers-profile-record',
        hidden: true,
        meta: { title: '报关记录', activeMenu: '/customers-profile/' }
      },
      {
        path: '/detail',
        component: () => import('@/views/admin/admin-clearance/detail/index.vue'),
        name: 'admin-clearance-detail-profile',
        meta: { title: '报关详情', activeMenu: '/customers-profile/' },
        hidden: true
      },
      {
        path: '/detail/:shipmentType',
        hidden: true,
        component: () => import('@/views/customers/customs-clearance/detail/index.vue'),
        name: 'customs-clearance-supply-detail',
        meta: { title: '报关申报', activeMenu: '' }
      },
      {
        path: '/detail-c/:shipmentType',
        hidden: true,
        component: () => import('@/views/customers/customs-clearance-c/detail/index.vue'),
        name: 'customs-clearance-supply-detail-c',
        meta: { title: '报关申报', activeMenu: '' }
      },
      {
        path: '/detail-b/:shipmentType',
        hidden: true,
        component: () => import('@/views/customers/customs-clearance-b/detail/index.vue'),
        name: 'customs-clearance-supply-detail-b',
        meta: { title: '报关申报', activeMenu: '' }
      }
    ]
  },
  {
    path: '/platform-mgt',
    component: Layout,
    alwaysShow: true,
    meta: { title: '平台管理', icon: 'stafffalse-dark', roles: [roles.roleAdmin, roles.roleOperator], level: 1 },
    children: [
      {
        path: '/employee',
        component: () => import('@/views/admin/platform-mgt/employee/index.vue'),
        name: 'platform-mgt-employee',
        meta: { title: '员工管理', permissionTag: 'staff:management', level: 2 }
      },
      {
        path: '/roles',
        component: () => import('@/views/admin/platform-mgt/roles/index.vue'),
        name: 'platform-mgt-roles',
        meta: { title: '角色管理', permissionTag: 'roles:management', level: 2 }
      },
      {
        path: '/port',
        component: () => import('@/views/admin/platform-mgt/port/index.vue'),
        name: 'platform-mgt-port',
        meta: { title: '口岸管理', permissionTag: 'ports:management', level: 2 }
      },
      {
        path: '/add',
        component: () => import('@/views/admin/platform-mgt/add/index.vue'),
        name: 'platform-mgt-add',
        meta: { title: '添加员工', activeMenu: '/employee/' },
        hidden: true
      }
    ]
  }
]
